import { useEffect, useState } from "react";
import api from "@/lib/api";

/**
 * Small, discreet site visit counter for the footer.
 * Read-only — the actual tracking POST is handled by <SiteVisitTracker />
 * so the counter here just reflects the latest total after mount.
 */
export default function VisitCounter() {
  const [visits, setVisits] = useState(null);

  useEffect(() => {
    let cancelled = false;
    // Small delay so the tracker's initial POST lands first and this GET
    // reflects the incremented total on a fresh session.
    const t = setTimeout(() => {
      api
        .get("/stats")
        .then(({ data }) => { if (!cancelled) setVisits(data.visits); })
        .catch((err) => console.error("Visit counter failed to load:", err));
    }, 400);
    return () => { cancelled = true; clearTimeout(t); };
  }, []);

  if (visits === null) return null;

  return (
    <span
      data-testid="footer-visits"
      className="text-[0.65rem] tracking-[0.28em] uppercase text-[#B8BCC2] font-light"
    >
      {visits.toLocaleString()} visits
    </span>
  );
}
